import useAuth from "hooks/useAuth";
import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import { Key, PersonCircle } from "react-bootstrap-icons";
import Logo from "assets/black-logo.png";
import { toast } from "react-toastify";

const FastLogin = ({ setFastLogin }) => {
  // contexts

  // hooks
  const { loading, data, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // functions
  const doLogin = (e, email, password) => {
    e.preventDefault();
    if (!!email && !!password) {
      login(email.toLowerCase(), password);
    } else {
      toast.error("Please enter your email and password.");
    }
  };

  useEffect(() => {
    if (!loading && data) {
      setFastLogin(false);
    }
  }, [loading]);

  return (
    <Container
      fluid
      className="bg-dark bg-opacity-25 h-100vh position-fixed top-0 bg-blurred"
      style={{ zIndex: 11 }}
    >
      <Row className="d-flex justify-content-center align-items-center h-100">
        <Col
          xs={12}
          md={8}
          lg={4}
          className="bg-light rounded-4 text-center p-3"
        >
          <Image src={Logo} width="35em" className="position-relative left-0" />
          <h5 className="mb-4 text-secondary">Please login again</h5>
          <Form onSubmit={(e) => doLogin(e, email, password)}>
            <div className="d-flex align-items-center">
              <PersonCircle size={25} color="grey" className="me-2" />
              <Form.Control
                id="email"
                type="email"
                name="email"
                className="rounded-5"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </div>
            <div className="d-flex align-items-center mt-2">
              <Key size={25} color="grey" className="me-2" />
              <Form.Control
                id="password"
                type="password"
                name="password"
                className="rounded-5"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </div>
            <Button type="submit" className="mt-3" disabled={loading}>
              {!loading && "Login"}
              {loading && <Spinner size="sm" />}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default FastLogin;
